module.exports = __webpack_public_path__ + "6d630a0470099eed11e0bd00088f9c79.svg";